import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    username: '',
    usuarioRolId: 0,
    usuarioRol: null,
    usuarioRolNombre: null,
    email: '',
    emailPassword: '',
    apellido: '',
    nombre: '',
    avatar: '',
    inactivo: false,
    rowVersion: null,
    
    usuarioDatos: [],
    usuarioDatosRolId: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR_USUARIO'(state, usuarioId) {
        state.id = usuarioId;
        state.username = '';
        state.usuarioRolId = 0;
        state.usuarioRol = null;
        state.usuarioRolNombre = null;
        state.email = '';
        state.emailPassword = '';
        state.apellido = '';
        state.nombre = '';
        state.avatar = '';
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_USUARIO'(state, usuario) {
        state.username = usuario.username.toUpperCase().trim();
        state.usuarioRolId = (usuario.usuarioRol) ? usuario.usuarioRol.id : 0;
        state.usuarioRol = usuario.usuarioRol;
        state.usuarioRolNombre = (usuario.usuarioRol) ? usuario.usuarioRol.nombre.toUpperCase().trim() : null;
        state.email = usuario.email.toUpperCase().trim();
        state.emailPassword = usuario.emailPassword.trim();
        state.apellido = usuario.apellido.toUpperCase().trim();
        state.nombre = usuario.nombre.toUpperCase().trim();
        state.avatar = usuario.avatar.toUpperCase().trim();
        state.inactivo = usuario.inactivo;
        state.rowVersion = usuario.rowVersion;
    },
    'USUARIO_ROL'(state, usuarioRol) {
        state.usuarioRolId = (usuarioRol) ? usuarioRol.id : 0;
        state.usuarioRol = usuarioRol;
        state.usuarioRolNombre = (usuarioRol) ? usuarioRol.nombre.toUpperCase().trim() : null;
    },

    'INICIALIZAR_DATOS' (state) {
        state.usuarioDatos = [];
        state.usuarioDatosRolId = 0;
    },
    'SET_USUARIO_DATOS' (state, params) {
        state.usuarioDatos = params.datos;
        state.usuarioDatosRolId = params.usuarioRolId;
    }
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, usuarioId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_USUARIO', usuarioId);

            if (usuarioId != 0) {
                apiAxios.get('usuarios/' + usuarioId + '/abm' ) 
                    .then(res => {
                        commit('SET_USUARIO', res.data);
                        resolve();
                    })
                    .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let usuario= {
                username: state.username.toUpperCase().trim(),
                usuarioRolId: state.usuarioRolId,
                usuarioRol: state.usuarioRol,
                apellido: state.apellido.toUpperCase().trim(),
                nombre: state.nombre.toUpperCase().trim(),
                avatar: state.avatar.toUpperCase().trim(),
                email: state.email.toLowerCase().trim(),
                emailPassword: state.emailPassword.trim(),
                inactivo: state.inactivo,
            }

            let url = 'usuarios';
            if (state.id != 0) {
                url += '/' + state.id;
                usuario.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, usuario)
                .then(() => resolve())
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
        })
    },
    inactivar ( {}, usuarioId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('usuarios/' + usuarioId + '/inactivar')
                .then(() => resolve())
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setUsuarioRol: ({commit}, usuarioRol) => {
        commit('USUARIO_ROL', usuarioRol);
    },
    getDatos ( { commit }, usuarioId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (usuarioId != 0) {
                apiAxios.get('usuarios/' + usuarioId ) 
                .then(res => {
                    let datos = [
                        { 'nombre': 'username', 'campo': 'Username', 'valor': res.data.username, 'formato': '' },
                        { 'nombre': 'apellido', 'campo': 'Apellido', 'valor': res.data.apellido, 'formato': '' },
                        { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                        { 'nombre': 'usuarioRol', 'campo': 'Rol', 'valor': res.data.usuarioRol, 'formato': '' },
                        { 'nombre': 'email', 'campo': 'Email', 'valor': res.data.email, 'formato': '' },
                        { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo) ? 'Si' : 'No', 'formato': '' },
                    ];

                    let params= {
                        datos,
                        usuarioRolId: res.data.usuarioRolId
                    }

                    commit('SET_USUARIO_DATOS', params);
                    resolve();
                })
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}